import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"

class CIICategoryChart extends Component<any> {
    Chart = () => {
        return {
            color: ['#058742', '#8bc63e', '#f7ee21', '#fbb03f', '#f3786e'],
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: '5%',
                left: 'center'
            },
            series: [
                {
                    name: 'Vessels',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    center: ['50%', '70%'],
                    // adjust the start and end angle
                    startAngle: 180,
                    endAngle: 360,
                    data: [
                        { value: this.props.graphData?.a, name: 'A' },
                        { value: this.props.graphData?.b, name: 'B' },
                        { value: this.props.graphData?.c, name: 'C' },
                        { value: this.props.graphData?.d, name: 'D' },
                        { value: this.props.graphData?.e, name: 'E' }
                    ]
                }
            ]
        }
    }
    render() {
        return (
            <>
                <h6 className="text-center">No. of vessels according to CII category</h6>
                <ReactEcharts style={{ height: "350px" }} option={this.Chart()} />
            </>
        )
    }
}

export default CIICategoryChart;